import { AuthAtoms } from "@/modules/plus/auth/plus.auth.atoms";
import { DataAtoms } from "@/modules/plus/data/plus.data.atoms";
import { SuggestionsAtoms } from "@/modules/plus/data/plus.suggestions.atoms";
import { ModelsAtoms } from "@/modules/plus/models/plus.models.atoms";
import { PhotosAtoms } from "@/modules/plus/photos/plus.photos.atoms";
import { ReportsAtoms } from "@/modules/plus/reports/plus.reports.atoms";
import { SearchAtoms } from "@/modules/plus/search/plus.search.atoms";

// Root atom container — instantiates each feature's AtomClass once and exposes
// them as `atoms.<feature>`. Cross-references (e.g., ModelsAtoms reading
// `this.atoms.data.templates`) are evaluated at atom-read time, so the
// construction order here doesn't need to match the dependency order.

export class AtomContainer {
  public auth: AuthAtoms = new AuthAtoms(this);
  public data: DataAtoms = new DataAtoms(this);
  public suggestions: SuggestionsAtoms = new SuggestionsAtoms(this);
  public search: SearchAtoms = new SearchAtoms(this);
  public models: ModelsAtoms = new ModelsAtoms(this);
  public photos: PhotosAtoms = new PhotosAtoms(this);
  public reports: ReportsAtoms = new ReportsAtoms(this);
}

export const atoms = new AtomContainer();
